import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./InterviewsUIHelpers";

const InterviewsUIContext = createContext();

export function useInterviewsUIContext() {
  return useContext(InterviewsUIContext);
}

export const InterviewsUIConsumer = InterviewsUIContext.Consumer;

export function InterviewsUIProvider({ preInterviewId, interviewsUIEvents, children }) {
  initialFilter.filter.preInterviewId = preInterviewId; // Ön Görüşme Id Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    openNewInterviewModal: interviewsUIEvents.openNewInterviewModal,
    openEditInterviewModal: interviewsUIEvents.openEditInterviewModal
  };

  return (
    <InterviewsUIContext.Provider value={value}>
      {children}
    </InterviewsUIContext.Provider>
  );
}